var map = {
	"./chat-icon-bottom-nav-mobile-active.webp": 2722,
	"./chat-icon-bottom-nav-mobile.webp": 2723,
	"./home-icon-bottom-nav-mobile-active.webp": 2724,
	"./home-icon-bottom-nav-mobile-active_b.webp": 2725,
	"./home-icon-bottom-nav-mobile.webp": 2726,
	"./home-icon-bottom-nav-mobile_b.webp": 2727,
	"./me-icon-bottom-nav-mobile-active.webp": 2728,
	"./me-icon-bottom-nav-mobile.webp": 2729,
	"./promo-icon-bottom-nav-mobile-active.webp": 2730,
	"./promo-icon-bottom-nav-mobile.webp": 2731,
	"./sponsor-icon-bottom-nav-mobile-active.webp": 2732,
	"./sponsor-icon-bottom-nav-mobile.webp": 2733,
	"./stream-icon-bottom-nav-mobile-active.webp": 2734,
	"./stream-icon-bottom-nav-mobile.webp": 2735
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2721;